<template>
  <div class="modal-card" style="width: 600px">
    <header class="modal-card-head">
      <p class="modal-card-title">העבר קטגוריה: {{ categoryName }}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <div class="move-dialog-content">
        <p class="help-text">בחר קטגוריה אב חדשה או העבר לשורש (ללא אב):</p>
        
        <div class="root-option">
          <label class="radio-label">
            <input 
              type="radio" 
              :value="null" 
              v-model="selectedParentId"
              name="parent"
            />
            <span class="root-text">שורש (ללא קטגוריה אב)</span>
          </label>
        </div>

        <div class="categories-tree">
          <div class="tree-section-title">או בחר קטגוריה אב:</div>
          <div class="tree-container">
            <tree-node
              v-for="category in availableCategories"
              :key="category.id"
              :category="category"
              :selected-id="selectedParentId"
              :disabled-ids="disabledIds"
              @select="selectParent"
            />
          </div>
        </div>

        <div v-if="selectedParentId" class="selected-info">
          <b-icon icon="check-circle" type="is-success"></b-icon>
          <span>נבחר: {{ getSelectedCategoryName() }}</span>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <b-button type="is-success" @click="confirmMove" :disabled="!canMove">אשר</b-button>
      <b-button @click="$emit('close')">ביטול</b-button>
    </footer>
  </div>
</template>

<script>
import TreeNode from './TreeNode.vue';

export default {
  name: 'DialogMoveCategory',
  components: {
    TreeNode
  },
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    },
    currentParentId: {
      type: Number,
      default: null
    },
    allCategories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedParentId: this.currentParentId
    };
  },
  computed: {
    disabledIds() {
      // Disable the category itself and all its descendants
      const ids = [this.categoryId];
      this.addDescendantIds(this.categoryId, ids);
      return ids;
    },
    availableCategories() {
      // Filter out disabled categories from the tree
      return this.filterTree(this.allCategories);
    },
    canMove() {
      // Allow move if parent changed (including null for root)
      return this.selectedParentId !== this.currentParentId;
    }
  },
  methods: {
    selectParent(categoryId) {
      this.selectedParentId = categoryId;
    },
    confirmMove() {
      this.$emit('confirm', {
        categoryId: this.categoryId,
        newParentId: this.selectedParentId
      });
      this.$emit('close');
    },
    addDescendantIds(categoryId, idsArray) {
      const category = this.findCategoryById(categoryId, this.allCategories);
      if (category && category.children) {
        category.children.forEach(child => {
          idsArray.push(child.id);
          this.addDescendantIds(child.id, idsArray);
        });
      }
    },
    findCategoryById(id, categories) {
      for (const cat of categories) {
        if (cat.id === id) return cat;
        if (cat.children) {
          const found = this.findCategoryById(id, cat.children);
          if (found) return found;
        }
      }
      return null;
    },
    filterTree(categories) {
      return categories
        .filter(cat => !this.disabledIds.includes(cat.id))
        .map(cat => ({
          ...cat,
          children: cat.children ? this.filterTree(cat.children) : []
        }));
    },
    getSelectedCategoryName() {
      if (!this.selectedParentId) return 'שורש';
      const category = this.findCategoryById(this.selectedParentId, this.allCategories);
      return category ? category.name : '';
    }
  }
};
</script>

<style scoped lang="scss">
.move-dialog-content {
  min-height: 300px;
}

.help-text {
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.root-option {
  margin-bottom: 20px;
  padding: 12px;
  background-color: #f0f8ff;
  border: 2px solid #d0e8ff;
  border-radius: 6px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 500;

  input[type="radio"] {
    cursor: pointer;
  }
}

.root-text {
  color: #2c3e50;
  font-size: 15px;
}

.categories-tree {
  margin-bottom: 20px;
}

.tree-section-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #2c3e50;
}

.tree-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  background-color: #fafafa;
}

.selected-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  color: #155724;
  font-weight: 500;
}

.modal-card-foot {
  justify-content: flex-start;
}
</style>
